<template>
    <div
        v-bind:style="item.style"
        :title="item.values"
    >
      <span v-bind:class="item.class">
        {{item.values || '-' }}
      </span>
    </div>
</template>
<script>
    export default {
        name: 'TableTypeDefault',
        props: ['item'],
    }
</script>